import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=7131d1ec&scoped=true"
import script from "./Surveys.js?vue&type=script&lang=js&external"
export * from "./Surveys.js?vue&type=script&lang=js&external"
import style0 from "./Surveys.scss?vue&type=style&index=0&id=7131d1ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7131d1ec",
  null
  
)

export default component.exports